import React from "react";
import { Loader2 } from "lucide-react";

export function Spinner({ label = "Loading", className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-2 py-10 text-[#4B5A60] ${className}`}>
      <Loader2 className="w-5 h-5 animate-spin" />
      <span className="text-sm">{label}...</span>
    </div>
  );
}

export function SkeletonCard() {
  return (
    <div className="sm-card p-5 animate-pulse">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-full bg-[#EDE9E1]" />
        <div className="flex-1 space-y-2">
          <div className="h-4 w-32 bg-[#EDE9E1] rounded" />
          <div className="h-3 w-20 bg-[#EDE9E1] rounded" />
        </div>
      </div>
      <div className="mt-4 space-y-2">
        <div className="h-3 w-full bg-[#EDE9E1] rounded" />
        <div className="h-3 w-4/5 bg-[#EDE9E1] rounded" />
      </div>
    </div>
  );
}
